exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(/src/assets/vendor/owl.carousel2/owl.carousel.min.css);", ""]);
exports.push([module.id, "@import url(/src/assets/vendor/custom-icon/style.css);", ""]);
exports.push([module.id, "@import url(/src/assets/vendor/font-awesome/css/font-awesome.min.css);", ""]);
exports.push([module.id, "@import url(/src/assets/css/newstoday.min.css);", ""]);

// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition-duration:.6s;transition-property:opacity;transition-timing-function:ease}.fade-enter,.fade-leave-active{opacity:0}.btn-info,.vueperslides__bullet .default{color:#fff}.btn-info{background-color:#052962;border-color:#052962}.btn-info:hover{background-color:#093f96}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5008bc79","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 63
// module chunks = 0